<h1 mat-dialog-title class="notification-title">{{ header }}</h1>

<mat-dialog-content class="transfer-error-content">
	<p>{{ message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-flat-button mat-dialog-close color="primary">
		{{ 'general.close' | translate }}
	</button>
</mat-dialog-actions>
